<template>
  <ExhibitionContainer
    :trade-show-name="'Parcel Forum \'26'"
    :activation-message="'Please scan your badge QR code'"
    has-badge-number-input
    :ble-id="label_id"
    :asset-id="asset_id"
    :token="t"
    :form-id="hubspotIds.formId"
    :portal-id="hubspotIds.portalId"
    :region="hubspotIds.region"
  >
    <template slot="banner">
      <Banner
        booth-number="Stand 807"
      />
    </template>
  </ExhibitionContainer>
</template>
<script>
import ExhibitionContainer from '../../components/organisms/exhibitions/exhibition-container';
import Banner from '../../components/molecules/exhibitions/parcel-forum-2026-banner';

export default {
  name: 'ParcelForum2026',
  components: {
    ExhibitionContainer,
    Banner,
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    label_id: { type: String, required: true },
    // eslint-disable-next-line vue/prop-name-casing
    asset_id: { type: String, required: true },
    t: { type: String, default: '' },
  },
  computed: {
    hubspotIds() {
      return {
        formId: '34fefb73-f936-477d-b79f-efc557fd44bb',
        portalId: '27004227',
        region: 'eu1',
      };
    },
  },
};
</script>
